export default __webpack_public_path__ + "static/media/2.8725c3ce.png";